var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSino(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.92487 0.599976C4.85074 0.599976 3.82061 1.02667 3.06109 1.78619C2.30156 2.54572 1.87487 3.57585 1.87487 4.64998V7.07053L1.39764 7.54775C1.30327 7.64215 1.23901 7.76241 1.21297 7.89333C1.18694 8.02425 1.20031 8.15994 1.25139 8.28327C1.30246 8.40659 1.38896 8.512 1.49993 8.58617C1.61091 8.66034 1.74139 8.69995 1.87487 8.69998H9.97487C10.1084 8.69995 10.2388 8.66034 10.3498 8.58617C10.4608 8.512 10.5473 8.40659 10.5984 8.28327C10.6494 8.15994 10.6628 8.02425 10.6368 7.89333C10.6107 7.76241 10.5465 7.64215 10.4521 7.54775L9.97487 7.07053V4.64998C9.97487 3.57585 9.54817 2.54572 8.78865 1.78619C8.02913 1.02667 6.999 0.599976 5.92487 0.599976ZM5.92487 11.4C5.3878 11.4 4.87274 11.1866 4.49298 10.8069C4.11322 10.4271 3.89987 9.91204 3.89987 9.37498H7.94987C7.94987 9.91204 7.73652 10.4271 7.35676 10.8069C6.977 11.1866 6.46193 11.4 5.92487 11.4Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSino);
export default __webpack_public_path__ + "static/media/sino.f85225fe7c9e9e93ea7083bceea2119a.svg";
export { ForwardRef as ReactComponent };